var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93832 7.81907L14.5 12.3806L19.038 7.8427C19.1383 7.73601 19.259 7.65066 19.3931 7.59178C19.5271 7.53289 19.6716 7.50167 19.818 7.5C20.1315 7.5 20.432 7.6245 20.6537 7.84612C20.8753 8.06774 20.9998 8.36832 20.9998 8.68173C21.0026 8.82662 20.9757 8.97053 20.9208 9.10465C20.8659 9.23877 20.7842 9.36027 20.6807 9.46168L16.0836 13.9995L20.6807 18.5965C20.8755 18.787 20.9897 19.045 20.9998 19.3173C20.9998 19.6307 20.8753 19.9313 20.6537 20.1529C20.432 20.3746 20.1315 20.4991 19.818 20.4991C19.6674 20.5053 19.5171 20.4802 19.3768 20.4252C19.2364 20.3703 19.109 20.2868 19.0026 20.18L14.5 15.6185L9.95013 20.1682C9.85028 20.2713 9.73099 20.3537 9.59915 20.4104C9.4673 20.4672 9.32552 20.4974 9.18198 20.4991C8.86855 20.4991 8.56796 20.3746 8.34633 20.1529C8.1247 19.9313 8.00019 19.6307 8.00019 19.3173C7.99744 19.1725 8.02432 19.0285 8.07919 18.8944C8.13406 18.7603 8.21576 18.6388 8.31927 18.5374L12.9164 13.9995L8.31927 9.40259C8.1245 9.21205 8.01028 8.95402 8.00019 8.68173C8.00019 8.36832 8.1247 8.06774 8.34633 7.84612C8.56796 7.6245 8.86855 7.5 9.18198 7.5C9.4656 7.50355 9.73741 7.61817 9.93832 7.81907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.c3c205205da9fb80ea81e151b9b2a8d4.svg";
export { ForwardRef as ReactComponent };